import BasicResource from '@/api/resource';

class OffersResource extends BasicResource {

    constructor () {
        super('offers');
    }

    bannersList (id) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/offers/${id}/banners`,
        });
    }

    capsList (id) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/offers/${id}/caps`,
        });
    }

    addCap (id, payload) {
        return this.client.request ({
            method: 'post',
            path: `/upyield/v1/offers/${id}/caps`,
            data: payload,
        });
    }

    updateCap (offerId, capId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/${offerId}/caps/${capId}`,
            data: payload,
        });
    }

    removeCap (offerId, capId) {
        return this.client.request ({
            method: 'delete',
            path: `/upyield/v1/offers/${offerId}/caps/${capId}`,
        });
    }

    revenuesHistoryList (id, params) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/offers/${id}/revenues`,
            params,
        });
    }

    payoutsHistoryList (id, params) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/offers/${id}/payouts`,
            params,
        });
    }

    capsHistoryList (id, params) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/offers/${id}/history?entity_type=OfferCap`,
            params,
        });
    }

    dict (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/dict/offers',
            params: params,
        });
    }

    uploadImagePreview (id, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/${id}/upload`,
            data: payload,
        });
    }

    removeImagePreview (id) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/${id}/remove-preview`,
        });
    }

    alerts (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/offers/alerts',
            data: params,
        });
    }

    checker (id, params) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/offers/${id}/checker`,
            data: params,
        });
    }

    confirmAlert (id, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/${id}/confirm-alert`,
            data: payload,
        });
    }

    cancelAlert (id, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/${id}/cancel-alert`,
            data: payload,
        });
    }

    activate (offerId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/${offerId}/unpause`,
        });
    }

    pause (offerId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/${offerId}/pause`,
        });
    }

    bulkPause (payload) {
        return this.client.request ({
            method: 'put',
            path: '/upyield/v1/offers/bulk-pause',
            data: payload,
        });
    }

    bulkResume (payload) {
        return this.client.request ({
            method: 'put',
            path: '/upyield/v1/offers/bulk-unpause',
            data: payload,
        });
    }

    activateLink (linkId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/link/${linkId}/unpause`,
        });
    }

    pauseLink (linkId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/link/${linkId}/pause`,
        });
    }

    pauseLinks (offerId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/${offerId}/link/bulk-pause`,
            data: payload,
        });
    }

    resumeLinks (offerId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/${offerId}/link/bulk-unpause`,
            data: payload,
        });
    }

    disableLinksFraudProtection (offerId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/${offerId}/link/bulk-fraud-protection-disable`,
            data: payload,
        });
    }

    enableLinksFraudProtection (offerId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/${offerId}/link/bulk-fraud-protection-enable`,
            data: payload,
        });
    }

    removeBanner (offerId, bannerId) {
        return this.client.request ({
            method: 'delete',
            path: `/upyield/v1/offers/${offerId}/banners/${bannerId}`,
        });
    }

    removePayoutRevenue (offerId, payoutId) {
        return this.client.request ({
            method: 'delete',
            path: `/upyield/v1/offers/${offerId}/payouts/${payoutId}`,
        });
    }

    removePayoutForLink (linkId, eventTypeId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/link/${linkId}/budget`,
            data: [ {
                event_type_id: eventTypeId,
                payout: null,
                revenue: null,
            } ],
        });
    }

    partnerRunningOffersList (partnerId, params) {
        params = {
            ...params,
            running: [ partnerId ],
        };

        return this.list(params);
    }

    partnerNotRunningOffersList (partnerId, params) {
        params = {
            ...params,
            not_running: [ partnerId ],
            not_blocked: [ partnerId ],
            response_type: 'simple',
        };

        return this.list(params);
    }

    partnerAvailableOffersList (excludedOffersIds, params) {
        params = {
            ...params,
            ...excludedOffersIds.length ? { exclude_id: excludedOffersIds } : {},
            response_type: 'simple',
        };

        return this.list(params);
    }

    partnersList (offerId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/offers/${offerId}/tracking-links`,
            params: params,
        });
    }

    pixelsList (offerId) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/offers/${offerId}/pixels`,
        });
    }

    applicablePartners (offerId, params) {
        return this.client.request({
            method: 'GET',
            path: `/upyield/v1/offers/${offerId}/applicable-partners`,
            params,
        });
    }

    changeFraudProtection (offerId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/link/${offerId}/fraud-protection`,
            data: payload,
        });
    }

    refreshUrlChecker (offerId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/${offerId}/refresh-url-checker`,
        });
    }

    changeTracking (offerId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/link/${offerId}/tracking`,
            data: payload,
        });
    }

    payoutsForLink (linkId, params) {
        return this.client.request ({
            method: 'GET',
            path: `/upyield/v1/offers/link/${linkId}/payouts`,
            params,
        });
    }

    capsForLink (linkId, params) {
        return this.client.request ({
            method: 'GET',
            path: `/upyield/v1/offers/link/${linkId}/history?entity_type=TrackingLinkCap`,
            params,
        });
    }

    addPayoutRevenue (id, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/${id}/budget`,
            data: [ payload ],
        });
    }

    addPayoutForLink (linkId, payload) {
        delete payload.event_type;

        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/link/${linkId}/budget`,
            data: [ payload ],
        });
    }

    addCapForLink (linkId, payload) {
        delete payload.event_type;

        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/offers/link/${linkId}/caps`,
            data: [ payload ],
        });
    }

    removeCapForLink (linkId, capId) {
        if (typeof linkId === 'undefined' || typeof capId === 'undefined') return;

        return this.client.request ({
            method: 'delete',
            path: `/upyield/v1/offers/link/${linkId}/caps/${capId}`,
        });
    }

    toggleOfferFeaturedStatus (offerId, featured) {
        if (featured) {
            return this.client.request({
                method: 'put',
                path:   `/upyield/v1/offers/${offerId}/unfeature`,
            });
        } else {
            return this.client.request({
                method: 'put',
                path:   `/upyield/v1/offers/${offerId}/feature`,
            });
        }
    }

    reportDownload (params) {
        return this.client.download({
            method: 'get',
            responseType: 'blob',
            path: '/upyield/v1/offers/download',
            params,
        });
    }

    reportShortDownload (params) {
        return this.client.download({
            method: 'get',
            responseType: 'blob',
            path: '/upyield/v1/offers/short_list_download',
            params,
        });
    }

    impressionPixelsList (offerId) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/offers/${offerId}/impression-pixels`,
        });
    }

    directLinksList (offerId) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/offers/${offerId}/direct-links`,
        });
    }

    saveAdvertiserPixel (offerId, url) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/offers/${offerId}/advertiser-postback`,
            data: { url },
        });
    }

    landingPages (offerId, params) {
        return this.client.request ({
            method: 'GET',
            path: `/upyield/v1/offers/${offerId}/landing-pages`,
            params,
        });
    }

    addLandingPage (offerId, data) {
        return this.client.request ({
            method: 'POST',
            path: `/upyield/v1/offers/${offerId}/landing-pages`,
            data,
        });
    }

    updateLandingPages (offerId, data) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/offers/${offerId}/landing-pages`,
            data,
        });
    }

    updateLandingPage (offerId, lpId, data) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/offers/${offerId}/landing-pages/${lpId}`,
            data,
        });
    }

    enableLandingPage (offerId, lpId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/offers/${offerId}/landing-pages/${lpId}/enable`,
        });
    }

    disableLandingPage (offerId, lpId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/offers/${offerId}/landing-pages/${lpId}/disable`,
        });
    }

    deleteLandingPage (offerId, lpId) {
        return this.client.request ({
            method: 'DELETE',
            path: `/upyield/v1/offers/${offerId}/landing-pages/${lpId}`,
        });
    }

    retrieveLandingPage (offerId, lpId) {
        return this.client.request ({
            method: 'GET',
            path: `/upyield/v1/offers/${offerId}/landing-pages/${lpId}/retrieve`,
        });
    }

    downloadBanners (offerId) {
        return this.client.download({
            method: 'get',
            responseType: 'blob',
            path: `/upyield/v1/offers/${offerId}/download-banners`,
        });
    }

    setBlacklistedTspParams ({ tspId, data }) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/offers/link/${tspId}/query-filtering`,
            data,
        });
    }

    updateServerSideClick (offerId, data) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/offers/${offerId}/server-side-click`,
            data,
        });
    }

    enableServerSideClick (offerId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/offers/${offerId}/server-side-click/enable`,
        });
    }

    disableServerSideClick (offerId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/offers/${offerId}/server-side-click/disable`,
        });
    }

    enableTrafficSplit (offerId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/offers/${offerId}/traffic-split/enable`,
        });
    }

    disableTrafficSplit (offerId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/offers/${offerId}/traffic-split/disable`,
        });
    }

    enableAdvertiserWhitelist (offerId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/offers/${offerId}/whitelist-ips-enable`,
        });
    }

    disableAdvertiserWhitelist (offerId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/offers/${offerId}/whitelist-ips-disable`,
        });
    }

    enableOptimizations (offerId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${offerId}/optimizations-enable`,
        });
    }

    disableOptimizations (offerId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${offerId}/optimizations-disable`,
        });
    }

    updateOptimizations (offerId, data) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${offerId}/optimizations`,
            data,
        });
    }

    trackingLinksReportDownload (offerId) {
        return this.client.download({
            method: 'get',
            responseType: 'blob',
            path: `/upyield/v1/${this.resourceName}/${offerId}/tracking-links/download`,
        });
    }

    getOptimizations (offerId) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${offerId}/optimizations`,
        });
    }

    createOptimization (offerId, data) {
        return this.client.request({
            method: 'post',
            path: `/upyield/v1/${this.resourceName}/${offerId}/optimizations`,
            data,
        });
    }

    updateOptimization (offerId, optimizationId, data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${offerId}/optimizations/${optimizationId}`,
            data,
        });
    }

    deleteOptimization (offerId, optimizationId) {
        return this.client.request({
            method: 'delete',
            path: `/upyield/v1/${this.resourceName}/${offerId}/optimizations/${optimizationId}`,
        });
    }

    enableOptimization (offerId, optimizationId) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${offerId}/optimizations/${optimizationId}/enable`,
        });
    }

    disableOptimization (offerId, optimizationId) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${offerId}/optimizations/${optimizationId}/disable`,
        });
    }

    retrieveOptimization (offerId, optimizationId) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${offerId}/optimizations/${optimizationId}/retrieve`,
        });
    }

    getCreativeRequests (offerId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${offerId}/creatives-requests`,
            params: params,
        });
    }

    createCreativeRequest (offerId, data) {
        return this.client.request({
            method: 'post',
            path: `/upyield/v1/${this.resourceName}/${offerId}/creatives-requests`,
            data,
        });
    }

    updateCreativeRequest (offerId, creativeRequestId, data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${offerId}/creatives-requests/${creativeRequestId}`,
            data,
        });
    }

    deleteCreativeRequest (offerId, creativeRequestId) {
        return this.client.request({
            method: 'delete',
            path: `/upyield/v1/${this.resourceName}/${offerId}/creatives-requests/${creativeRequestId}`,
        });
    }

    enableCreativeRequest (offerId, creativeRequestId) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${offerId}/creatives-requests/${creativeRequestId}/enable`,
        });
    }

    disableCreativeRequest (offerId, creativeRequestId) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${offerId}/creatives-requests/${creativeRequestId}/disable`,
        });
    }

    retrieveCreativeRequest (offerId, creativeRequestId) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${offerId}/creatives-requests/${creativeRequestId}/retrieve`,
        });
    }
}

export default new OffersResource;
